import { FC } from "react";
import { ConnectPlaid } from "@components/plaid/ConnectPlaid/ConnectPlaid";
import { CreateMercuryConnection } from "@components/mercury/CreateMercuryConnection";
import { CreateRampConnection } from "@components/ramp/CreateRampConnection";
import { PLAID_INSTITUTIONS_NAMES } from "@common/constants";
import { useAccountsConnectionContext } from "@components/financialAccount/AccountConnectionWidget/AccountsConnectionContext";
import { Command } from "@vendor/cmdk/cmdk";
import { useCommands } from "./useCommands";
import { CommandItem } from "@design-system/CommandItem/CommandItem";
import { InstitutionIcon } from "@design-system/InstitutionIcon/InstitutionIcon";

export const OnboardingCommandsList: FC = () => {
    const { defaultEntity } = useAccountsConnectionContext();

    const { close: closeCommands } = useCommands();

    return (
        <Command.Group heading="Popular">
            <CreateMercuryConnection
                onCreated={closeCommands}
                defaultEntity={defaultEntity}
            >
                {({ connecting, initializeConnection }) => (
                    <CommandItem
                        onSelect={initializeConnection}
                        disabled={connecting}
                        keywords={["mercury"]}
                    >
                        <InstitutionIcon institution="mercury" size="sm" />{" "}
                        Mercury
                    </CommandItem>
                )}
            </CreateMercuryConnection>

            <CreateRampConnection
                onCreated={closeCommands}
                defaultEntity={defaultEntity}
            >
                {({ connecting, initializeConnection }) => (
                    <CommandItem
                        onSelect={initializeConnection}
                        disabled={connecting}
                    >
                        <InstitutionIcon institution="ramp" size="sm" /> Ramp
                    </CommandItem>
                )}
            </CreateRampConnection>

            <ConnectPlaid
                onConnected={closeCommands}
                institutionName={PLAID_INSTITUTIONS_NAMES.CHASE}
                defaultEntity={defaultEntity}
            >
                {({ connecting, initializeConnection }) => (
                    <CommandItem
                        onSelect={initializeConnection}
                        disabled={connecting}
                        keywords={["chase"]}
                    >
                        <InstitutionIcon institution="chase" size="sm" /> Chase
                    </CommandItem>
                )}
            </ConnectPlaid>

            <ConnectPlaid
                onConnected={closeCommands}
                institutionName={PLAID_INSTITUTIONS_NAMES.AMERICAN_EXPRESS}
                defaultEntity={defaultEntity}
            >
                {({ connecting, initializeConnection }) => (
                    <CommandItem
                        onSelect={initializeConnection}
                        disabled={connecting}
                        keywords={["american express", "amex"]}
                    >
                        <InstitutionIcon institution="amex" size="sm" />{" "}
                        American Express{" "}
                    </CommandItem>
                )}
            </ConnectPlaid>

            <ConnectPlaid
                onConnected={closeCommands}
                institutionName={PLAID_INSTITUTIONS_NAMES.CAPITAL_ONE}
                defaultEntity={defaultEntity}
            >
                {({ connecting, initializeConnection }) => (
                    <CommandItem
                        onSelect={initializeConnection}
                        disabled={connecting}
                        keywords={["capital one"]}
                    >
                        <InstitutionIcon institution="capital-one" size="sm" />{" "}
                        Capital One{" "}
                    </CommandItem>
                )}
            </ConnectPlaid>

            <ConnectPlaid
                onConnected={closeCommands}
                institutionName={PLAID_INSTITUTIONS_NAMES.BANK_OF_AMERICA}
                defaultEntity={defaultEntity}
            >
                {({ connecting, initializeConnection }) => (
                    <CommandItem
                        onSelect={initializeConnection}
                        disabled={connecting}
                        keywords={["bank of america", "boa"]}
                    >
                        <InstitutionIcon
                            institution="bank-of-america"
                            size="sm"
                        />{" "}
                        Bank of America{" "}
                    </CommandItem>
                )}
            </ConnectPlaid>

            <ConnectPlaid
                onConnected={closeCommands}
                institutionName={PLAID_INSTITUTIONS_NAMES.WELLS_FARGO}
                defaultEntity={defaultEntity}
            >
                {({ connecting, initializeConnection }) => (
                    <CommandItem
                        onSelect={initializeConnection}
                        disabled={connecting}
                        keywords={[
                            "wellsfargo",
                            "wells fargo",
                            "wells",
                            "fargo",
                        ]}
                    >
                        <InstitutionIcon institution="wells-fargo" size="sm" />{" "}
                        Wells Fargo
                    </CommandItem>
                )}
            </ConnectPlaid>

            <ConnectPlaid
                onConnected={closeCommands}
                institutionName={PLAID_INSTITUTIONS_NAMES.CITIBANK}
                defaultEntity={defaultEntity}
            >
                {({ connecting, initializeConnection }) => (
                    <CommandItem
                        onSelect={initializeConnection}
                        disabled={connecting}
                        keywords={["citibank", "citi bank", "citi"]}
                    >
                        <InstitutionIcon institution="citi" size="sm" />{" "}
                        Citibank
                    </CommandItem>
                )}
            </ConnectPlaid>
        </Command.Group>
    );
};
